import { Box, Flex, HStack, Stack } from '@chakra-ui/react';
import {
  BaseButton,
  createFieldHelper,
  FormContainer,
  renderFieldHelperInput,
  useHookForm
} from '@cks-internal/react-base';
import { faEraser, faSearch } from '@fortawesome/free-solid-svg-icons';
import { ApiEndpoints } from '../../constants/endpoints/apiEndpoints.ts';
import { EntityNotesFilterModel } from './types/entityNotesFilterModel';

type Props = {
  filterState: EntityNotesFilterModel;
  onFilterChange: (model: EntityNotesFilterModel) => void;
  onCreate: () => void;
};

export const EntityNotesFilters = (props: Props) => {
  const { formMethods } = useHookForm<EntityNotesFilterModel>(props.filterState);
  const helper = createFieldHelper<EntityNotesFilterModel>(formMethods);

  const fields = [
    helper.hiddenInput('EntityNoteQueryType'),
    helper.textInput('Search'),
    helper.switchInput('Active').withContainerProps({ maxW: '140px' }).withLabel('Active'),
    helper
      .multiSelectQueryItems('EntityNoteTypes', {
        searchUrl: ApiEndpoints.selectOptions.enum('EntityNoteType', true)
      })
      .withLabel('Note Types')
  ];

  return (
    <Box width={'100%'}>
      <FormContainer methods={formMethods} onSubmit={props.onFilterChange} hideControls={true}>
        <Flex alignItems={'start'} justifyContent={'space-between'} gap={'8px'}>
          <Flex minW={'250px'} w={'100%'} flex={1} alignItems={'center'} gap={'8px'}>
            {renderFieldHelperInput('Search', fields)}
            {renderFieldHelperInput('EntityNoteTypes', fields)}
          </Flex>
          <Stack>
            <HStack ml={'auto'}>
              {renderFieldHelperInput('Active', fields)}
              <BaseButton
                marginTop={'23px'}
                backgroundColor={'secondary.500'}
                _hover={{ backgroundColor: 'tertiary.200' }}
                height={'35px'}
                aria-label='clear'
                alignSelf={'baseline'}
                onClick={() => {
                  formMethods.reset({
                    Search: '',
                    Active: true
                  });
                }}
                icon={faEraser}
              />
              <BaseButton
                marginTop={'23px'}
                height={'35px'}
                type='submit'
                aria-label='submit'
                alignSelf={'baseline'}
                icon={faSearch}
              />
            </HStack>
          </Stack>
        </Flex>
      </FormContainer>
    </Box>
  );
};
